import { render, staticRenderFns } from "./AddLayerPanel.vue?vue&type=template&id=fa60cdae&scoped=true"
import script from "./AddLayerPanel.vue?vue&type=script&lang=ts"
export * from "./AddLayerPanel.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./AddLayerPanel.vue?vue&type=style&index=0&id=fa60cdae&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fa60cdae",
  null
  ,true
)

export default component.exports